import React from 'react';
import styled from 'styled-components';
import giftIcon from './icons/gift.svg'; // Assuming you have the icon as a separate asset

// Styled components
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Popup = styled.div`
  display: flex;
  width: 328px;
  height: 269px;
  padding: 32px 12px 12px 12px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: 4px;
  border: 1px solid rgba(90, 90, 90, 0.25);
  background: #191A17;
  text-align: center;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

const Message = styled.p`
  font-size: 16px;
  color: white;
  margin: 8px 0;
`;

const CloseButton = styled.button`
  background: #364b56;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  margin-top: 16px;

  &:hover {
    background: #2b3d46;
  }
`;

const SuccessPopup = ({ message, onClose }) => {
  return (
    <Overlay>
      <Popup>
        <IconWrapper>
          <Icon src={giftIcon} alt="Gift Icon" />
        </IconWrapper>
        <Message>{message}</Message>
        <CloseButton onClick={onClose}>Close</CloseButton>
      </Popup>
    </Overlay>
  );
};

export default SuccessPopup;
